import { useEffect, useState } from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import Text from '@common/text';
import { useChatCompanyChannelByChannelId } from '@repository/chat/useChat';
import Colors from '@domain/constant/colors';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface CompanyBtnProps {
  channelId: string | undefined;
}

const CompanyBtn = ({ channelId }: CompanyBtnProps) => {
  const [visible, setVisible] = useState<boolean>(false);

  const { data } = useChatCompanyChannelByChannelId(channelId || '');

  useEffect(() => {
    setVisible(data?.managed || false);

    return () => {
      setVisible(false);
    };
  }, [data]);

  if (!visible || !data?.companySn) return null;

  return (
    <Link href={V2Route.getCompanyChannelPage(data.companySn)} className={cx('btn')}>
      <Icon name={'businessLight'} fill={Colors.C_WHITE} width={24} height={24} />
      <Text className={cx('text')} color={Colors.C_WHITE}>
        기업 정보
      </Text>
    </Link>
  );
};

export default CompanyBtn;
